module.exports = __webpack_public_path__ + "img/02.4fdb2b1b.png";